"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _componentsWeb = require("@telus-uds/components-web");
var _dataAttributes = require("../utils/dataAttributes");
var _excluded = ["decorative", "weight"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
var Divider = _ref => {
  var {
      decorative = false,
      weight = 'Default'
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid, {
    dataSet: (0, _dataAttributes.mapDataAttrsToDataSet)(rest),
    gutter: false
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Row, {
    horizontalAlign: "center"
  }, /*#__PURE__*/_react.default.createElement(_componentsWeb.FlexGrid.Col, null, /*#__PURE__*/_react.default.createElement(_componentsWeb.Divider, {
    variant: {
      weight: weight === 'Default' ? undefined : weight === null || weight === void 0 ? void 0 : weight.toLowerCase(),
      decorative
    },
    testID: 'allium-divider-testid'
  }))));
};
Divider.propTypes = {
  weight: _propTypes.default.oneOf(['Default', 'Thick']),
  decorative: _propTypes.default.bool
};
var _default = exports.default = Divider;